var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobilePay = function SvgMobilePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "MobilePay_svg__a",
    x1: -123.04,
    x2: -123.04,
    y1: 71.14,
    y2: 71.15,
    gradientTransform: "matrix(32.94554 -13.6465 -90.59265 -218.71 10505.21 13894.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#514779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#514779",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#514779",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#514779",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#514779",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MobilePay_svg__b",
    x1: -110.41,
    x2: -110.41,
    y1: 67.49,
    y2: 67.5,
    gradientTransform: "matrix(-32.94554 13.6465 102.54768 247.572 -10550.92 -15184.68)",
    href: "#MobilePay_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MobilePay_svg__c",
    x1: 6.852,
    x2: 6.852,
    y1: 16.696,
    y2: 16.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#514779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#514779",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#514779",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#514779",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "MobilePay_svg__e",
    x1: 6.852,
    x2: 6.852,
    y1: 16.696,
    y2: 16.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#514779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#514779",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#514779",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "MobilePay_svg__d",
    d: "M7.78 17.18c-.89.37-1.63.88-2.12 1.49l-1.25-3.03c.57-.66 1.3-1.18 2.12-1.49.89-.37 1.79-.55 2.55-.44l1.25 3.03c-.87-.07-1.75.09-2.55.44"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#596fb4",
    d: "M5.04 22.09c-.35 0-.66-.21-.8-.53l-2.97-7.17a.86.86 0 0 1 .47-1.12l3.11-1.29a.86.86 0 0 1 1.12.47l2.97 7.17a.86.86 0 0 1-.47 1.12l-3.11 1.29a.9.9 0 0 1-.33.07zm.14-9.72a.4.4 0 0 0-.15.03l-3.11 1.29c-.2.08-.3.32-.21.52l2.97 7.17c.08.2.32.3.52.21l3.11-1.29c.2-.08.3-.32.21-.52l-2.97-7.17a.42.42 0 0 0-.37-.25z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#MobilePay_svg__a)",
    d: "m5.74 13.09.43-.18 1.18 2.84-.43.18z",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#MobilePay_svg__b)",
    d: "m8.74 19.14-.43.18-1.33-3.21.43-.18z",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#596fb4",
    d: "M7.78 17.18c-.89.37-1.63.88-2.12 1.49l-1.25-3.03c.57-.66 1.3-1.18 2.12-1.49.89-.37 1.79-.55 2.55-.44l1.25 3.03c-.87-.07-1.75.09-2.55.44"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#MobilePay_svg__c)",
    href: "#MobilePay_svg__d",
    opacity: 0.9,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#MobilePay_svg__e)",
    href: "#MobilePay_svg__d",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#596fb4",
    d: "M8.18 18.11c-.96 0-1.84.19-2.53.57v-3.06c.78-.39 1.65-.59 2.53-.57.96 0 1.86.18 2.53.57v3.06c-.78-.4-1.65-.59-2.53-.57m4.92 0 .78-2.46s.04-.06.07-.06h.39s.06.03.08.06l.61 1.55s.04.03.05 0l.6-1.55s.04-.06.08-.06h.39s.06.03.07.06l.77 2.46s0 .06-.03.08h-.49s-.06-.02-.07-.05l-.49-1.6s-.04-.03-.05 0l-.59 1.59s-.04.06-.08.06h-.27s-.06-.02-.08-.06l-.6-1.59s-.04-.03-.05 0l-.51 1.6s-.04.06-.07.05h-.44s-.06-.03-.06-.06v-.03zm4.04-.89a1.03 1.03 0 0 1 2.06-.04 1.03 1.03 0 0 1-1.01 1.05 1 1 0 0 1-1.05-.96zm1.53 0c-.02-.28-.26-.49-.54-.47s-.49.26-.47.54c.02.27.24.48.51.47.29-.01.51-.25.5-.54m1.44.81s-.07-.02-.07.03v.05s-.03.07-.07.07h-.36s-.07-.03-.07-.07v-2.46s.03-.07.07-.07h.38s.07.03.07.07v.7q0 .075.09.03c.15-.11.32-.17.5-.17.53 0 .93.44.93 1.01a.97.97 0 0 1-.92 1.01.8.8 0 0 1-.54-.21zm.94-.81c.02-.28-.19-.52-.47-.54s-.52.19-.54.47v.08c-.01.28.21.52.49.53a.51.51 0 0 0 .51-.53zm.84-1.47a.3.3 0 0 1 .3-.3c.17 0 .3.13.3.3s-.13.3-.3.3-.3-.13-.3-.3m.03 2.36v-1.79s.03-.07.07-.07h.38s.08.03.08.07v1.78s-.03.07-.07.07h-.39s-.07-.03-.07-.07zm.95-.58v-1.88s.03-.07.07-.07h.38s.07.03.07.07v1.9c0 .12.05.2.19.2.04 0 .07.03.07.07v.31s-.03.07-.07.07c-.5 0-.71-.17-.71-.67m.92-.3a.99.99 0 0 1 1-.99c.55.01 1 .45.99 1 0 .07-.02.13-.09.13h-1.32s-.05.02-.04.05a.44.44 0 0 0 .47.38.46.46 0 0 0 .36-.17q.045-.06.12-.06h.35c.06 0 .09.04.06.1-.25.5-.85.71-1.35.46-.35-.17-.56-.52-.57-.91zm1.4-.18s.04-.01.03-.04a.45.45 0 0 0-.88-.01c0 .03 0 .05.03.05zm.91 1.06v-2.46s.03-.07.07-.07h1.21c.55 0 .93.32.93.86s-.43.88-.95.88h-.64s-.07.02-.07.06v.74s-.03.07-.07.07h-.4s-.07-.03-.07-.07zm1.25-1.24c.23 0 .41-.2.4-.43a.4.4 0 0 0-.38-.41h-.66s-.06.02-.06.07v.7s.02.07.06.07h.65zm1.14.35c-.02-.54.4-.99.94-1.01a.75.75 0 0 1 .52.2c.03.03.07.03.07-.02v-.05s.03-.07.07-.07h.36s.07.03.07.07v1.27c0 .1.03.14.1.15.03 0 .06.03.06.06v.33s-.03.06-.06.06c-.25 0-.4-.07-.49-.22-.02-.04-.05-.05-.09 0-.16.17-.39.26-.62.26a.965.965 0 0 1-.94-1zm1.53 0c.02-.28-.19-.52-.47-.54s-.52.19-.54.47v.08c-.02.28.19.52.47.54s.52-.19.54-.47zm.85 1.64v-.31s.03-.07.07-.07a.53.53 0 0 0 .55-.37c.01-.05 0-.1-.01-.15l-.71-1.6s0-.08.03-.09h.42s.06.03.08.07l.44 1.02c.03.08.08.08.12 0l.42-1.02s.03-.06.07-.06h.36s.07.03.07.06v.03l-.73 1.72c-.26.63-.54.86-1.11.86-.04 0-.07-.03-.07-.07z"
  })));
};
export default SvgMobilePay;